import {
  createDefaultSaleExpensesFilters,
  createDefaultSaleFeesFilters,
  createInitialExpenseSummary,
  createInitialFeeSummary,
} from '@/composables/sales/saleDetail/state';
import { getExpensesFilterOptions } from '@/composables/expenses/useExpensesList';
import { getFeesFilterOptions } from '@/composables/fees/useFeesList';
import { createSupplierDetailTabs } from '@/composables/suppliers/useSupplierDetailTabs';

export const createSupplierDetailState = (text = null) => ({
  loading: false,
  supplier: null,
  supplierOverview: null,
  persons: [],
  contributors: [],
  activeTab: 'summary',
  tabs: createSupplierDetailTabs(text),
  showMoreActionsMenu: false,
  isSupplierEditModalOpen: false,
  supplierEditSectionKey: 'general',
  isSupplierSubmitting: false,
  isConfirmActionModalOpen: false,
  pendingActionType: '',
  pendingActionSupplier: null,
  isMergeModalOpen: false,
  mergeSubmitting: false,
  isContributorModalOpen: false,
  isContributorListModalOpen: false,
  contributorModalMode: 'create',
  contributorModalInitialData: null,
  isContributorSubmitting: false,
  isPersonModalOpen: false,
  personModalMode: 'create',
  personModalInitialData: null,
  isPersonSubmitting: false,
  isExpenseModalOpen: false,
  isExpenseSubmitting: false,
  expenseModalMode: 'create',
  expenseModalInitialData: null,
  expenseLoading: false,
  expenseRows: [],
  expenseFilterOptions: getExpensesFilterOptions(),
  expenseFilters: createDefaultSaleExpensesFilters(),
  expenseSearchText: '',
  expenseSearchDebounceMs: 1000,
  expenseSearchDebounceTimer: null,
  expenseActiveStatusTab: 'all',
  expenseCurrentPage: 1,
  expensePageSize: 20,
  expenseListRequestToken: 0,
  expenseMetricsRequestToken: 0,
  expenseInFlightRequestKey: '',
  expenseFiltersLoaded: false,
  expenseSummary: createInitialExpenseSummary(),
  isApproveExpenseModalOpen: false,
  isApprovingExpense: false,
  approveExpenseTarget: null,
  approveExpenseTargetState: true,
  isPayExpenseModalOpen: false,
  isPayExpenseSubmitting: false,
  payExpenseTarget: null,
  isDeleteExpenseModalOpen: false,
  isDeletingExpense: false,
  deleteExpenseTarget: null,
  isFeeModalOpen: false,
  isFeeSubmitting: false,
  feeModalMode: 'create',
  feeModalInitialData: null,
  feeLoading: false,
  feeRows: [],
  feeFilterOptions: getFeesFilterOptions(),
  feeFilters: createDefaultSaleFeesFilters(),
  feeSearchText: '',
  feeSearchDebounceMs: 1000,
  feeSearchDebounceTimer: null,
  feeActiveStatusTab: 'all',
  feeCurrentPage: 1,
  feePageSize: 20,
  feeListRequestToken: 0,
  feeMetricsRequestToken: 0,
  feeInFlightRequestKey: '',
  feeFiltersLoaded: false,
  feeSummary: createInitialFeeSummary(),
  isApproveFeeModalOpen: false,
  isApprovingFee: false,
  approveFeeTarget: null,
  approveFeeTargetState: true,
  isPayFeeModalOpen: false,
  isPayFeeSubmitting: false,
  payFeeTarget: null,
  isDeleteFeeModalOpen: false,
  isDeletingFee: false,
  deleteFeeTarget: null,
  countryOptions: [],
  stateOptions: [],
  regimenOptions: [],
  usoCfdiOptions: [],
  paymentMethodOptions: [],
  paymentMethodTypeOptions: [],
});
